import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const ImageSlider = ({ name, id, list }) => {
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered custom-modal-size"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header bg-gray-700 p-4">
            <h5 className="modal-title text-white" id="domainlLabel">
              {name} Images
            </h5>
            <button
              type="button"
              className="close opacity-100"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" className="ki ki-close text-white"></i>
            </button>
          </div>
          <div className="modal-body p-3 custom-modal-size">
            <div className="verifi-slider review-slider">
              <Carousel showIndicators={false} showThumbs={false}>
                {(Array.isArray(list?.imageUrl) && list.imageUrl.length > 0
                  ? list.imageUrl
                  : Array.isArray(list)
                  ? list
                  : []
                ).map((img, index) => (
                  <div key={index.toString()}>
                    {img && (
                      <img
                        src={img}
                        className="w-100 max-w-350px"
                        style={{ objectFit: "contain" }}
                        alt=""
                      />
                    )}
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
